var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('wxlogin',{attrs:{"appid":"wxd9eb1abb57cad81f","self_redirect":'true',"scope":'snsapi_login',"theme":'black',"redirect_uri":encodeURIComponent("https://www.baigongbao.com/test/wx_qrcode"),"href":'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZxxx=',"rel":"external nofollow"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }